import { render, staticRenderFns } from "./InfoHargaBahanBaru.vue?vue&type=template&id=7a4e5666&scoped=true"
import script from "./InfoHargaBahanBaru.vue?vue&type=script&lang=js"
export * from "./InfoHargaBahanBaru.vue?vue&type=script&lang=js"
import style0 from "./InfoHargaBahanBaru.vue?vue&type=style&index=0&id=7a4e5666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e5666",
  null
  
)

export default component.exports